import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import requestApi from "../../../../api/api";

export const addSpouse = createAsyncThunk('spouseForm/addSpouse', async (spouse, thunkAPI) => {
  if (spouse) {
    return spouse;
  }
  return thunkAPI.rejectWithValue(null);
})

export const editSpouse = createAsyncThunk('spouseForm/editSpouse', async (spouse, thunkAPI) => {
  if (spouse) {
    return spouse;
  }
  return thunkAPI.rejectWithValue(null);
})

export const getAllSpouseByPersonId = createAsyncThunk('spouseForm/getAllSpouseByPersonId', async (param, thunkAPI) => {
  try {
    if(param) {
      const response = await requestApi(`/marriage-person/all/${param}`, 'GET');
      return response;
    }
    return [];
  } catch (error) {
    // console.log('error-------->', error.response.data.message);
    if (error.response && error.response.data.message) {
      return thunkAPI.rejectWithValue(error.response.data.message);
    } else {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
})

const spouseFormSlice = createSlice({
  name: 'spouseForm',
  initialState: {
    listSpouse: [],
    listSpouseByPersonId: [],
    isLoading: false,
    errorMessage: null,
    spouseId: 0,
  },
  reducers: {},
  extraReducers: {
    [addSpouse.pending]: (state) => {
      state.isLoading = true;
      state.errorMessage = null;
    },
    [addSpouse.rejected]: (state, action) => {
      state.isLoading = false;
      state.errorMessage = action.payload;
    },
    [addSpouse.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.listSpouse = [...state.listSpouse, action.payload];
      // console.log('addSpouse fulfilled------>', action.payload);
    },

    [editSpouse.pending]: (state) => {
      state.isLoading = true;
      state.errorMessage = null;
    },
    [editSpouse.rejected]: (state, action) => {
      state.isLoading = false;
      state.errorMessage = action.payload;
    },
    [editSpouse.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.listSpouse = action.payload
      // console.log('editSpouse fulfilled------>', action.payload);
    },

    [getAllSpouseByPersonId.pending]: (state, action) => {
      state.isLoading = true;
      state.errorMessage = null;
    },
    [getAllSpouseByPersonId.rejected]: (state, action) => {
      state.isLoading = false;
      state.errorMessage = action.payload;
    },
    [getAllSpouseByPersonId.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.listSpouseByPersonId = action.payload.data;
      // console.log('getAllSpouseByPersonId fulfilled------>', action.payload.data.data.items);
    },
  }
})
const { reducer: spouseFormReducer } = spouseFormSlice;
export default spouseFormReducer;